// extracted by mini-css-extract-plugin
export default {"container":"TermsOfUse_container__HcZW1","title":"TermsOfUse_title__Laqc4","content":"TermsOfUse_content__DVIHK","link":"TermsOfUse_link__Q5kaC"};